import React from 'react'
import PropTypes from 'prop-types'
import { Comment } from '@aok/text-elements'

import ModuleContainer from '../../_layout/Module/ModuleContainer'
import LinkTitle from '../../atoms/LinkTitle/LinkTitle'
import LinkHeadline from '../../molecules/LinkHeadline/LinkHeadline'
import ClickableTileWrapper from '../../atoms/ClickableTileWrapper/ClickableTileWrapper'

import defaultProps from '../../../utils/propTypes/defaultProps'

const Y015 = ({ headline, elements }) => {
  return (
    <ModuleContainer dataTrackingName="Y015">
      <LinkHeadline headline={headline} className="mb-32" />

      <Comment text="googleoff: all" />
      <ul className="grid grid-cols-1 gap-x-16 gap-y-40 600:grid-cols-2 600:gap-y-48 720:gap-x-24 840:grid-cols-3 1000:gap-x-32">
        {elements.map((element, index) => {
          return (
            <ClickableTileWrapper key={index} url={element.link?.url} target={element.link?.target}>
              <p className="mb-8 font-regular text-6d767c text-16 leading-24">{element.subtitle}</p>
              <LinkTitle
                url={element.link?.url}
                title={element.link?.title}
                target={element.link?.target}
                asHeadline={false}
              />
            </ClickableTileWrapper>
          )
        })}
      </ul>
      <Comment text="googleon: all" />
    </ModuleContainer>
  )
}

Y015.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
    url: PropTypes.string,
  }),
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      subtitle: PropTypes.string,
      link: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
      }),
    })
  ),
}

Y015.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  elements: [
    {
      subtitle: defaultProps.SUBTITLE,
      link: {
        title: defaultProps.TITLE,
        url: '#',
      },
    },
  ],
}

export default Y015
